import { IReparcelingsRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisReparcelingsRepository from './implementations/VectisReparcelingsRepository';

let instance: IReparcelingsRepository | null = null;

export default function makeReparcelingsRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisReparcelingsRepository(httpProvider);
  }

  return instance;
}
